import React, {DetailedHTMLProps, InputHTMLAttributes} from "react";
import {FieldValues} from "react-hook-form/dist/types/fields";
import {UseFormRegister} from "react-hook-form/dist/types/form";
import {FieldErrors} from "react-hook-form/dist/types/errors";
import {Control} from "react-hook-form/dist/types";
import {ComboBoxMesi} from "./comboBox/ComboBoxMesi";
import {MONTHS} from "@utilities/constAppUtils";
import Input from "./wrapperComponents/Input";
import * as Validation from "@utilities/validationRules";
import {ComboButton} from "./ComboButton";
import {useAppSelector} from "@hooks/redux-hooks/hooks";
import {selectIsBusy} from "@commons/core.slice";
import {IconPlayerPlayFilled, IconPlayerTrackNextFilled, IconPlayerTrackPrevFilled, IconReload} from "@tabler/icons-react";

interface PeriodoRifProps<T extends FieldValues> extends Pick<DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>, 'className'> {
    register?: UseFormRegister<T>,
    errors?: FieldErrors<T>,
    control: Control<T>,

    nameComboMese: string,
    nameAnno: string,
    disableMonth?: boolean,
    prevMonth?: () => void,
    nextMonth?: () => void,
    reload?: () => void,
    apply?: () => void,
    disabled?: boolean,
}

const PeriodoRif: React.FC<PeriodoRifProps<any>> = ({
                                                        register,
                                                        errors,
                                                        control,

                                                        nameComboMese,
                                                        nameAnno,
                                                        disableMonth,
                                                        prevMonth,
                                                        nextMonth,
                                                        reload,
                                                        apply,
                                                        className,
                                                        disabled = false,
                                                    }) => {

    if (!register)
        throw new Error('Non hai specificato <register>!');

    const isBusy: boolean = useAppSelector(selectIsBusy);
// console.log('isBusy',isBusy)
    return (
        <div className="flex flex-row w-full">
            <div className={`flex flex-row ${className}`}>
                <div className="w-1/2 px-2">
                    <label className="font-medium">Anno</label>
                    <Input name={nameAnno} register={register} errors={errors} registerOptions={{...Validation.required, valueAsNumber: true,}}
                           id={nameAnno} min={1900} maxLength={4}
                           className={`appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm mt-1
                           disabled:opacity-50 read-only:opacity-70
                           focus:outline-none focus:ring-blue-500 focus:border-blue-500`}
                    />
                </div>
                <div className="w-1/2 px-2">
                    <ComboBoxMesi data={MONTHS} name={nameComboMese} control={control}
                                  classNameCombo={errors && errors[nameComboMese] ? 'border-rose-700' : 'border-gray-300'} disabled={disableMonth}/>
                </div>
            </div>
            {(prevMonth || nextMonth || apply) && <div className={`flex flex-row grow items-end`}>
                {prevMonth && <div>
                    <ComboButton onClick={prevMonth} Icon={IconPlayerTrackPrevFilled} disabled={isBusy}/>
                </div>}
                {nextMonth && <div>
                    <ComboButton onClick={nextMonth} Icon={IconPlayerTrackNextFilled} disabled={isBusy}/>
                </div>}
                {reload && <div>
                    <ComboButton onClick={reload} Icon={IconReload} disabled={isBusy || !disabled}/>
                </div>}
                {apply && <div className="ml-auto">
                    <ComboButton onClick={apply} Icon={IconPlayerPlayFilled} disabled={isBusy || disabled}>Applica</ComboButton>
                </div>}
            </div>
            }
        </div>
    )
}
export default PeriodoRif;